module.exports = __webpack_public_path__ + "static/media/Home Cleaning Services.cd0ffcc4.webp";